var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tile" }, [
    _c("div", {
      staticStyle: { "margin-top": "-110px", float: "left" },
      attrs: { id: _vm.link + "-tile-link" },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "tile__header" }, [_vm._t("tileHeader")], 2),
    _vm._v(" "),
    _c("div", { staticClass: "tile__content" }, [_vm._t("tileContent")], 2),
    _vm._v(" "),
    _c("div", { staticClass: "tile__footer" }, [_vm._t("tileFooter")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }